'use strict';

module.exports = function() {
    return function(n) {
		var res = [];
		for (var i = 0; i < n; i++) {
			res.push(i);
		}

		return res;
    };
};